<template lang="pug">
v-container(
  fluid
  pa-0
  px-4
  ma-0
  py-1
)
  v-row(dense justify-space-between align="center")
    v-col(cols="auto")
      div(class=" tw-rounded tw-overflow-hidden")
        div(
          :class="this.$formatters.oppStageColor(opportunity.stage)"
          class="py-3 mx-1 tw-w-20 tw-text-center rounded-pill d-inline-block"
        )
          span(class="tw-text-sm tw-font-bold tw-text-white") {{ this.$formatters.formatValue(opportunity.amount) }}
    v-col(cols="stretch")
      v-row(no-gutters)
        v-col
          router-link(class="tw-font-medium text-link" :to="{ name: 'opportunityDetail', params: { id: opportunity.id } }") {{ opportunity.name }}
      v-row(no-gutters justify="space-between" align="center")
        v-col(cols="stretch" class="pr-2")
          v-progress-linear(
            rounded
            height="6"
            :color="progress.color"
            background-color="blue-grey lighten-5"
            :value="progress.value"
          )
        v-col(cols="auto" class=" tw-text-right  ")
          span(class=" tw-text-sm tw-font-semibold tw-text-blueGray-lighten-1") {{ opportunity.tasks_completed }} / {{ opportunity.tasks_total }}
    v-col(cols="auto")
      v-row(no-gutters justify="end")
        v-col(class="tw-text-right ")
          div(
            class=" tw-w-24 tw-py-2 tw-px-1 tw-rounded tw-font-bold tw-text-sm tw-text-center tw-bg-opacity-50 tw-bg-blueGray-lighten-5 tw-text-blueGray-lighten-2"
          )
            span(class="tw-text-sm tw-font-light") {{ this.$moment(opportunity.expected_close_date).format('MMM Do') }}
</template>
<script>
export default {
  props: ['opportunity'],

  computed: {
    progress: function () {
      let value = (this.opportunity.tasks_completed / this.opportunity.tasks_total) * 100;
      let progress = {};
      progress.value = value;
      switch (true) {
        case value <= 25:
          progress.color = '#FF808B';
          break;

        case value <= 50:
          progress.color = '#F4BE5E';
          break;

        case value <= 75:
          progress.color = '#5E81F4';
          break;

        case value <= 100:
          progress.color = '#7CE7AC';
          break;

        default:
          break;
      }
      return progress;
    },
  },
};
</script>
